module.exports = __webpack_public_path__ + "img/bo.171beb70.svg";